<template>
  <div class="home">
    <div class="home-content">
      <div class="weather">
        <!--         <img src="/static/images/weather.png" alt="" /> -->
        <div class="weather-time">
          <!-- <span>天气：{{ weather }}</span> -->
          <span>今天是{{ day }}</span>
        </div>
      </div>
      <div class="week">
        星期{{ weekList[week] }}
        <span>{{ time }}</span>
      </div>
      <div class="welcome">您好，欢迎来到丽企之家政务端平台！</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      weather: null,
      day: '',
      week: '',
      time: '',
      weekList: ['日', '一', '二', '三', '四', '五', '六']
    }
  },
  created() {
    this.timeList()
    // this.getWeather()
  },
  mounted() {
    setInterval(() => {
      this.timeList()
    }, 1000)
  },
  methods: {
    timeList() {
      var date = new Date()
      this.day =
        date.getFullYear() +
        '年' +
        (date.getMonth() + 1) +
        '月' +
        date.getDate() +
        '日'
      this.week = date.getDay()
      this.time = date.getHours() + ':' + this.check(date.getMinutes())
    },
    check(i) {
      var num = i < 10 ? '0' + i : i
      return num
    },
    /** 获取天气情况 */
    getWeather() {
      axios
        .get('http://wthrcdn.etouch.cn/weather_mini?city=丽水')

        .then((res) => {
          const data = res.data.data
          this.weather = data.forecast[0].type
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  &-content {
    display: flex;
    margin-top: 39px;

    .weather {
      display: flex;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.85);
      img {
        width: 40px;
        height: 40px;
      }
      &-time {
        margin-left: 17px;
        line-height: 22px;
        span {
          display: block;
        }
      }
    }
    .week {
      // height: 20px;
      padding: 0 18px 0 10px;
      margin: 0 26px 0 17px;
      font-size: 14px;
      // line-height: 26px;
      color: rgba(255, 255, 255, 100);
      border-right: 1px solid rgba(255, 255, 255, 0.2);
      border-left: 1px solid rgba(255, 255, 255, 0.2);
      span {
        margin-left: 13px;
      }
    }
    .welcome {
      // margin-top: 26px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
